<template>
  <div class="issue-severity-chip-cell" v-if='item && item.severity'>
    <issue-severity-chip :issue='item' />
  </div>
</template>

<script>
import actionToTakeTable from '@/mixins/actionToTakeTable';
import IssueSeverityChip from '@/components/common/IssueSeverityChip.vue';

export default {
  name: 'IssueSeverityChipTableCell',
  components: { IssueSeverityChip },
  mixins: [actionToTakeTable],
  computed: {
    columnName() {
      return this.column.name;
    },
    value() {
      return this.item[this.columnName];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.issue-severity-chip-cell {
  align-items: center;
  display: flex;
  width: rem(67);
  justify-content: center;
  .severity {
    text-transform: capitalize;
    align-items: center;
    display: flex;
    font-family: $font-family-semibold;
    font-size: $font-size-base;
    font-weight: bold;
    letter-spacing: 0;
    line-height: rem(17);
    justify-content: center;
    padding: $space-0-5 $space-1;
    border-radius: $radius-md;
  }
}

</style>
